import React from "react";
import HomeFooter from "../../components/home/footer/HomeFooter";
import HomeHeader from "../../components/home/header/HomeHeader";
import "./Home.css";

// #45c630

function Home() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <HomeHeader />
      <div className="wrapper" style={{ backgroundColor: "#45c630" }}>
        <div className="container">
          <div>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              동네기반 반려견
            </h1>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              올인원 플랫폼
            </h1>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div className="container">
          <div>
            <h1 style={{ fontSize: 60, margin: 0, color: "#45c630" }}>
              반려견 소개팅으로
            </h1>
            <h1 style={{ fontSize: 60, margin: 0, color: "#45c630" }}>
              친구 만들기
            </h1>
          </div>
        </div>
      </div>
      <div className="wrapper" style={{ backgroundColor: "#45c630" }}>
        <div className="container">
          <div>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              반려견 물품
            </h1>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              중고거래
            </h1>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div className="container">
          <div>
            <h1 style={{ fontSize: 60, margin: 0, color: "#45c630" }}>
              동네사람에게 맡기는
            </h1>
            <h1 style={{ fontSize: 60, margin: 0, color: "#45c630" }}>
              펫시터
            </h1>
          </div>
        </div>
      </div>
      <div className="wrapper" style={{ backgroundColor: "#45c630" }}>
        <div className="container">
          <div>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              미션을 통한
            </h1>
            <h1 style={{ fontSize: 60, margin: 0, color: "white" }}>
              성숙한 반려문화 형성
            </h1>
          </div>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
}

export default Home;
